import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const BankIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M3 12.9999H6V20.9999H4C3.73478 20.9999 3.48043 21.1052 3.29289 21.2928C3.10536 21.4803 3 21.7346 3 21.9999C3 22.2651 3.10536 22.5194 3.29289 22.707C3.48043 22.8945 3.73478 22.9999 4 22.9999H28C28.2652 22.9999 28.5196 22.8945 28.7071 22.707C28.8946 22.5194 29 22.2651 29 21.9999C29 21.7346 28.8946 21.4803 28.7071 21.2928C28.5196 21.1052 28.2652 20.9999 28 20.9999H26V12.9999H29C29.2176 12.9996 29.4292 12.9285 29.6026 12.7971C29.7761 12.6658 29.902 12.4815 29.9612 12.2721C30.0205 12.0627 30.0098 11.8398 29.9308 11.637C29.8519 11.4343 29.709 11.2628 29.5238 11.1486L16.5238 3.14862C16.3662 3.05176 16.1849 3.00049 16 3.00049C15.8151 3.00049 15.6338 3.05176 15.4762 3.14862L2.47625 11.1486C2.29103 11.2628 2.14811 11.4343 2.06916 11.637C1.99021 11.8398 1.97955 12.0627 2.03878 12.2721C2.09801 12.4815 2.22391 12.6658 2.39738 12.7971C2.57085 12.9285 2.78242 12.9996 3 12.9999ZM8 12.9999H12V20.9999H8V12.9999ZM18 12.9999V20.9999H14V12.9999H18ZM24 20.9999H20V12.9999H24V20.9999ZM16 5.17362L25.4675 10.9999H6.5325L16 5.17362ZM31 25.9999C31 26.2651 30.8946 26.5194 30.7071 26.707C30.5196 26.8945 30.2652 26.9999 30 26.9999H2C1.73478 26.9999 1.48043 26.8945 1.29289 26.707C1.10536 26.5194 1 26.2651 1 25.9999C1 25.7346 1.10536 25.4803 1.29289 25.2928C1.48043 25.1052 1.73478 24.9999 2 24.9999H30C30.2652 24.9999 30.5196 25.1052 30.7071 25.2928C30.8946 25.4803 31 25.7346 31 25.9999Z" />
  </svg>
);

BankIcon.propTypes = iconPropTypes;

export default BankIcon;
